// @flow

import { gql } from '@apollo/client';

const GET_PLAN_RECOMMENDATION = gql`
  query getHealthRecommendation(
    $zipcode: String!
    $region: Int!
    $countyFips: String!
    $state: String!
    $applicants: [ApplicantInput]!
    $planYear: Int!
    $onExchange: OnExchangeEnum
    $csr: CsrLevel
    $subsidy: Float
    $metalTypes: [HealthPlanMetalTypeEnum]
    $filterOptions: FilterOptions
  ) {
    getHealthRecommendation(
      zipcode: $zipcode
      region: $region
      countyFips: $countyFips
      state: $state
      applicants: $applicants
      planYear: $planYear
      onExchange: $onExchange
      csr: $csr
      subsidy: $subsidy
      metalTypes: $metalTypes
      filterOptions: $filterOptions
    ) {
      forecastMethod
      plans {
        flags
        mods {
          allInForecast
          forecasts {
            family {
              drugs {
                amount
                count
                totalRawCost
                ndc
              }
              services {
                amount
                count
                totalRawCost
                serviceType
              }
            }
            members {
              uuid
              drugs {
                amount
                count
                totalRawCost
                ndc
              }
              services {
                amount
                count
                totalRawCost
                serviceType
              }
            }
          }
          oop {
            drugsOop
            medicalOop
            totalOop
          }
          planId
          premiumMonth
          premiumYear
          providers {
            providersAccepted {
              accepted
              id
            }
            qtyNearby
            totalAccepted
          }
          ranks {
            strideRank
            allInForecastScore
            totalOopScore
          }
          savings {
            subsidy
          }
          userDrugs {
            annualForecast
            applicantId
            id
            ndc
          }
        }
        plan {
          benefits {
            masterId
            planMasterId
            planId
            csr
            benefitId
            inNetwork
            id
            versionActive
            preAmt
            preQty
            deductible
            payType
            amt
            amtDual
            daily
            serviceType
            coreVisit
          }
          carrierBrandId
          carrierId
          carrier
          logoUrl
          csr
          deductibleFam
          deductibleInd
          deductiblerxFam
          deductiblerxInd
          displayActive
          formularyId
          hsaStatus
          id
          masterId
          medicalCareRating
          memberExperienceRating
          metalType
          networkId
          onExchange
          oonDeductibleFam
          oonDeductibleInd
          oonOopmaxFam
          oonOopmaxInd
          oopmaxFam
          oopmaxInd
          overallRating
          planAdministrationRating
          planId
          planName
          planType
          planYear
          providerDirectoryUrl
          state
          qhpCrosslisted
          qhpStatus
          name
          fullName
          txnActive
          urlBuy
          urlPdf
          versionActive
        }
        special
        premiumMonth
      }
    }
  }
`;

export default GET_PLAN_RECOMMENDATION;
